
import { Component, Vue, ProvideReactive } from "vue-property-decorator"

import VuePerfectScrollbar from "vue-perfect-scrollbar"

import TabButton from "./TabButton.vue"

@Component({
	components: {
		"scrollbar": VuePerfectScrollbar,
		"tab-button": TabButton
	}
})
export default class ScrollTabs extends Vue {
	@ProvideReactive("tabControl") private tabsControl = this;
	@ProvideReactive("activeId") private currentTabUid: string | null = null;

	tabs: any[] = [];

	public currentTab: any = null;

	public get activeTab () {
		return this.currentTab ? this.currentTab : this.tabs[0]
	}
	public get activeId () {
		return this.currentTabUid
	}
	public set activeId (value: string | null) {
		this.currentTabUid = value
	}

	public get nonScrollTabs () {
		return this.tabs.filter(t => !t.scrollable)
	}
	public get scrollTabs () {
		return this.tabs.filter(t => t.scrollable)
	}

	created () {
		if (!this.tabs) {
			this.tabs = []
		}

		this.currentTab = null
		if (this.tabs.length > 0) {
			this.currentTab = this.tabs[0]
			this.activeId = this.tabs[0].id
		}
	}

	beforeDestroy () {
		this.activeId = null
	}

	public registerTab (tab: any): string {
		this.tabs.push(tab)

		if (!this.currentTab) {
			this.currentTab = tab
			this.activeId = this.tabs.length.toString()
		}
		return this.tabs.length.toString()
	}

	public unregisterTab (tab: any) {
		const tabIndex = this.tabs.indexOf(tab)
		if (tabIndex > -1) {
			this.tabs.splice(tabIndex, 1)
			if (tab.id === this.activeId) {
				this.activeId = this.tabs.length > 0 ? this.tabs[0].id : null
			}
		}
	}

	private setTab (newTab: any) {
		this.currentTab = newTab
		this.activeId = newTab.id
	}
}

